import React from 'react'

function Loader() {
  return (
    <>
      <img src="./img/loader.gif" alt="Loading..." /> 
    </>
  )
}

export default Loader
